// extracted by mini-css-extract-plugin
export default {"adfox":"Adfox-module__adfox--NXETc","adfoxHidden":"Adfox-module__adfoxHidden--nemRo","close":"Adfox-module__close--3PMfH"};